import React from 'react';
import styles from './profile.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faEnvelope, faIdCard, faRightFromBracket, faTimes, faCog, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../../utilities/auth/auth';
import { useNavigate } from 'react-router-dom';

const ProfileModal = ({ onClose, user }) => {
    const { logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        await logout();
        navigate('/login', { replace: true });
    };

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className={styles.modalOverlay} onClick={handleOverlayClick}>
            <div className={styles.modalContent}>
                {/* Modal Header */}
                <div className={styles.modalHeader}>
                    <h2>Profile Information</h2>
                    <button className={styles.closeButton} onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>

                {/* User Profile Section */}
                <div className={styles.profileSection}>
                    <div className={styles.avatar}>
                        {user?.username?.[0]?.toUpperCase() || 'U'}
                    </div>
                    <div className={styles.userDetails}>
                        <h3 className={styles.userName}>{user?.username || 'User'}</h3>
                        <p className={styles.userRole}>{user?.role || 'Administrator'}</p>
                        <p className={styles.userEmail}>
                            <FontAwesomeIcon icon={faEnvelope} className={styles.detailIcon} />
                            {user?.email || 'user@example.com'}
                        </p>
                        {user?.userId && (
                            <p className={styles.userId}>
                                <FontAwesomeIcon icon={faIdCard} className={styles.detailIcon} />
                                ID: {user.userId}
                            </p>
                        )}
                    </div>
                </div>

                {/* Additional Info Section */}
                <div className={styles.infoSection}>
                    <div className={styles.infoItem}>
                        <FontAwesomeIcon icon={faCog} className={styles.infoIcon} />
                        <div className={styles.infoContent}>
                            <span className={styles.infoLabel}>Status</span>
                            <span className={styles.infoValue}>Active</span>
                        </div>
                    </div>
                    <div className={styles.infoItem}>
                        <FontAwesomeIcon icon={faInfoCircle} className={styles.infoIcon} />
                        <div className={styles.infoContent}>
                            <span className={styles.infoLabel}>Last Login</span>
                            <span className={styles.infoValue}>Recently</span>
                        </div>
                    </div>
                </div>

                {/* Action Buttons */}
                <div className={styles.actionButtons}>
                    <button
                        className={styles.logoutButton}
                        onClick={handleLogout}
                    >
                        <FontAwesomeIcon icon={faRightFromBracket} />
                        Logout
                    </button>
                    <button
                        className={styles.cancelButton}
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ProfileModal;